/**
 * Runs `handle` over `items` in consecutive batches of `size`, one batch at a
 * time.
 *
 * Each batch is isolated: one that throws is handed to `onError` and the loop
 * moves on. Without this, a single batch whose hand-off rejected ended the
 * whole pick -- every later photo was silently never thumbnailed or added.
 */
export async function forEachBatch<T>(
  items: readonly T[],
  size: number,
  handle: (batch: T[], start: number) => void | Promise<void>,
  onError: (error: unknown, start: number) => void,
): Promise<void> {
  for (let start = 0; start < items.length; start += size) {
    try {
      await handle(items.slice(start, start + size), start);
    } catch (error) {
      try {
        onError(error, start);
      } catch {
        // Reporting must never be what stops the rest of the pick.
      }
    }
  }
}
